import { Div, Collection } from "@tblabs/truffle";
import { Order } from "../../../Models/Order";
import { AdminBasketTableItem } from "../../../Pages/Admin/OrdersView/Views/Table/Components/BasketTableItem";
import { BasketItem } from "../../../Models/Basket/BasketItem";


export class BasketCollectionPrinter extends Div
{
    constructor(order: Order, itemsIds?: Collection<string>)
    {
        super();

        let items: BasketItem[] =
            itemsIds?.Items
                ?.map(id => order.BasketItems.find(x => x.Id === id))
                ?.filter(x => x != null)
            ?? order.BasketItems;

        this.Append(
            ...items.map(item => new AdminBasketTableItem(item))
        );
    }
}
